import { useCallback, useLayoutEffect, useRef } from 'react';

export function useEvent<TCallback extends Function>(
  callback: TCallback,
): TCallback {
  const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return useCallback(
    ((...args: unknown[]) =>
      callbackRef.current(...args)) as unknown as TCallback,
    [],
  );
}
